export const COMPANY_DOCUMENTS_PATH = "/documents/company/";
